/*

 */

export const GENERIC_UI_SET_GENERIC_FORM_DIALOG_DATA = 'GENERIC_UI::SET_GENERIC_FORM_DIALOG_DATA';
